// extracted by mini-css-extract-plugin
export default {"hiddenEraser":"BFK89"};